import { Category } from '@v2/shared/lib/types';

import CategoriesPanel from '../CategoriesPanel';

type Props = {
  categories: Category[];
  featuredCategories: Category[];
  closeMainMenu: () => void;
};

export default function BooksMenu({ categories, featuredCategories, closeMainMenu }: Props) {
  return (
    <>
      <CategoriesPanel
        title="Our top categories"
        categories={categories}
        featuredCategories={featuredCategories}
        closeMainMenu={closeMainMenu}
      />
    </>
  );
}
